// Item.tsx
import { CustomerPaymentMethod } from '@@types'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { getPaymentMethodLogo } from '@shared/lib/paymentMethodLogos'
import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'

type Props = {
  data: CustomerPaymentMethod | null;
  isSelected: boolean;
  onSelect: () => void;
  type?: 'new-card';
};

export default function Item ({ data, isSelected, onSelect, type }: Props) {
  const isNewCard = data === null && type === 'new-card'
  const { t: to } = useTranslation('order')
  
  let iconSrc = '/icons/card.svg'
  let label = ''

  if (isNewCard) {
    iconSrc = '/icons/payments/crosshair.svg'
    label = to('new_card')
  } 
  else if (data) {
    iconSrc = getPaymentMethodLogo(data.card)
    label = `${to('card')} ****${data?.last}`
  }

  return (
    <div className={styles.item} onClick={onSelect} role="button" tabIndex={0}>
      <div className={styles.item__iconContainer}>
        <ReactSVG className={styles.item__iconWrapper} src={iconSrc} wrapper="span" />
      </div>
      <p>{label}</p>
      <Radio checked={isSelected} onChange={onSelect} />
    </div>
  )
}